import { TSliderValue, useDeviceType } from '@cian/ui-kit';
import { animate, utils } from 'animejs';
import { useCallback, useRef, useState } from 'react';
import { IncreaseImpressions } from 'shared/components/IncreaseImpressions';
import { ALL_VAS } from 'shared/constants/vas';
import { TVas } from 'shared/types/vas';
import { animateBigPin } from 'shared/utils/animatePins';

export const IncreaseImpressionsContainer: React.FC = () => {
  const device = useDeviceType();

  const [activeVas, setActiveVas] = useState<TVas>(ALL_VAS[0]);

  const [views] = useState({ value: '100' });

  const viewsRef = useRef<HTMLDivElement>(null);
  const prevMapPinRef = useRef<boolean | undefined>(activeVas.mapPin);
  const prevBackgroundColorRef = useRef<string | undefined>(activeVas.backgroundColor);
  const opacityAnimationRef = useRef<ReturnType<typeof animate> | null>(null);

  const handleChangeVas = useCallback(
    (value: TSliderValue) => {
      const [$log] = utils.$(viewsRef.current as HTMLDivElement);

      const newValue = ALL_VAS.find(item => item.vasId === value) as TVas;

      animate(views, {
        value: newValue.views,
        modifier: utils.round(0),
        onRender: () => ($log.textContent = views.value),
      });

      const hasMapPin = !!newValue.mapPin;

      if (hasMapPin && !prevMapPinRef.current) {
        animateBigPin(true);
      }

      prevMapPinRef.current = hasMapPin;
      setActiveVas(newValue);

      const backgroundColor = newValue.backgroundColor;

      if (prevBackgroundColorRef.current !== backgroundColor) {
        animate('#card', {
          backgroundColor,
        });
        prevBackgroundColorRef.current = backgroundColor;
      }

      if (opacityAnimationRef.current) {
        opacityAnimationRef.current.cancel();
      }

      opacityAnimationRef.current = animate('#mapPinContainer', {
        opacity: hasMapPin ? 1 : 0,
        duration: 300,
        onComplete: () => {
          if (!hasMapPin) {
            animateBigPin(false);
          }
          opacityAnimationRef.current = null;
        },
      });
    },
    [views],
  );

  return <IncreaseImpressions device={device} {...activeVas} viewsRef={viewsRef} onChangeActiveVas={handleChangeVas} />;
};
